import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex',
    title: 'md:heading-2xl-desk heading-2xl mb-4'
  }
});
